import { useQuery } from '@tanstack/react-query';
import { billing } from '@repletoryreach/sdk-api';

/** The list's key, for a refusal to invalidate: a provider switched off a moment ago. */
export const PAYMENT_PROVIDERS_KEY = ['payments', 'providers'] as const;

/**
 * The ways of paying the platform offers right now.
 *
 * The console used to keep this list itself, so a provider the platform had
 * switched off went on being offered and whoever chose it met an error
 * (21 September 2026). The platform is asked instead, often enough that a
 * switch shows within a minute. `data` stays undefined when the list cannot be
 * read, and a page then falls back to what it knew before rather than offering
 * nothing at all.
 */
export function usePaymentProviders() {
  return useQuery({
    queryKey: PAYMENT_PROVIDERS_KEY,
    queryFn: async () => (await billing.listPaymentProviders()).data,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
    retry: false
  });
}
